import pathfinder from '@fiverr-private/pathfinder';
import { PAGE_NAME } from '../../../shared/constants';

const APP_NAME = PAGE_NAME.BUYER_LANDING_PAGE;

const getFAQContent = () => [
    {
        question: 'logo_maker_perseus.buyer_landing_page.faq.question_1.question',
        answer: 'logo_maker_perseus.buyer_landing_page.faq.question_1.answer',
        link: pathfinder('logo_maker_tutorials_page'),
    },
    {
        question: 'logo_maker_perseus.buyer_landing_page.faq.question_2.question',
        answer: 'logo_maker_perseus.buyer_landing_page.faq.question_2.answer',
    },
    {
        question: 'logo_maker_perseus.buyer_landing_page.faq.question_3.question',
        answer: 'logo_maker_perseus.buyer_landing_page.faq.question_3.answer',
    },
    {
        question: 'logo_maker_perseus.buyer_landing_page.faq.question_4.question',
        answer: 'logo_maker_perseus.buyer_landing_page.faq.question_4.answer',
        link: pathfinder('logo_maker_pricing_page'),
    },
    {
        question: 'logo_maker_perseus.buyer_landing_page.faq.question_5.question',
        answer: 'logo_maker_perseus.buyer_landing_page.faq.question_5.answer',
        link: pathfinder('help_center_article', {
            article_id: '4662326669201-What-types-of-branding-packages-are-available',
        }),
    },
    {
        question: 'logo_maker_perseus.buyer_landing_page.faq.question_6.question',
        answer: 'logo_maker_perseus.buyer_landing_page.faq.question_6.answer',
    },
    {
        question: 'logo_maker_perseus.buyer_landing_page.faq.question_7.question',
        answer: 'logo_maker_perseus.buyer_landing_page.faq.question_7.answer',
    },
    {
        question: 'logo_maker_perseus.buyer_landing_page.faq.question_8.question',
        answer: 'logo_maker_perseus.buyer_landing_page.faq.question_8.answer',
        link: pathfinder('start_selling'),
    },
];

export { getFAQContent, APP_NAME };
